<script setup lang="ts">
import { ref } from "vue";
import { Training } from "@/types/training/Training";
import { useModal } from "@/utils/modal";
import { trainingService } from "@/app/services/TrainingService";
import { useLoader } from "@/utils/loader";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { onMounted } from "vue";
import { useCustomRouter } from "@/utils/router";
import Cover from "./organisms/Cover.vue";
import Question from "./organisms/Question.vue";
import { applicationService } from "@/app/services/ApplicationService";

const customRouter = useCustomRouter();
const route = useRoute();
const modal = useModal();
const loader = useLoader();
const training = ref<Training | null>(null);
const trainingStarted = ref(false);
const trainingId = computed((): string => {
  return route.params.trainingId as string;
});
const applicationId = computed((): number => {
  return Number(route.query.applicationId);
});

onMounted(() => {
  loadTraining();
});

async function loadTraining() {
  try {
    loader.show();
    training.value = (
      await trainingService.fetchTraining(trainingId.value)
    ).body;
  } catch (e) {
    await modal.msgBoxOk("トレーニングの取得に失敗しました。", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

async function onTrainingFinished() {
  try {
    loader.show();
    const application = await applicationService.fetchApplication(
      applicationId.value
    );
    if (!application) {
      await modal.msgBoxOk("応募情報の取得に失敗しました。", {
        centered: true
      });
      return;
    }
    await trainingService.finishTraining(
      trainingId.value,
      application.order.office.id
    );
    await customRouter.pushIgnoreError({
      name: "WorkStarted",
      params: { applicationId: applicationId.value.toString() }
    });
  } catch (e) {
    await modal.msgBoxOk("回答の登録に失敗しました。", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

function onClickStart() {
  trainingStarted.value = true;
}
</script>

<template>
  <div v-if="training" class="training-container">
    <div>
      <Question
        v-if="trainingStarted"
        :training="training"
        @finish="onTrainingFinished"
      />
      <Cover v-else :training="training" @start="onClickStart" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.training-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background-color: #fafafa;
}
</style>
